import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { serviceCenterStore } from 'App/ServiceCenter/store/serviceCenterStore'
import { apiFetch } from 'utils/apiFetch'
import { parse, type GeoJSONPoint } from 'wellknown'
import type { MetaWithNodeIdentifier } from './queue/types'

export type NodeDropInstallMeta = routes.ServiceCenterNodeDropInstall.Request & MetaWithNodeIdentifier

const request = async (meta: NodeDropInstallMeta): Promise<NodeDropInstallMeta> => {
  await apiFetch({ url: '/service-center-node-drop-install', body: meta })

  return meta
}

const callback = (meta: NodeDropInstallMeta): void => {
  const { nodeIdentifier, nodeType, propertyId, maintenanceOwnerId, location, blockId = null } = meta
  const parsedLocation = parse(location) as GeoJSONPoint

  parsedLocation.coordinates[0] = parseFloat(parsedLocation.coordinates[0].toFixed(6))

  parsedLocation.coordinates[1] = parseFloat(parsedLocation.coordinates[1].toFixed(6))

  const newActiveNode = {
    nodeIdentifier,
    location: JSON.stringify(parsedLocation),
    nodeType,
    propertyId,
    blockId,
    maintenanceOwnerId,
    name: meta.name || null,
  }

  serviceCenterStore.actions.addActiveNode(newActiveNode)
}

export const serviceCenterNodeDropInstall = {
  request,
  callback,
}
